import { Swiper, Pagination, Navigation } from 'swiper';

Swiper.use([Pagination, Navigation]);

function innitSwiper() {
  const sliders = new Swiper('.image-carousel .image-carousel-container', {
    loop: false,
    spaceBetween: 10,
    centeredSlidesBounds: true,
    centeredSlides: true,
    slidesPerView: 1.2,
    a11y: true,
    keyboardControl: true,
    grabCursor: true,
    autoHeight: false,
    navigation: {
      nextEl: '.image-carousel .swiper-button-next',
      prevEl: '.image-carousel .swiper-button-prev',
    },
    pagination: {
      el: '.image-carousel .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      650: {
        slidesPerView: 2.2,
        spaceBetween: 20,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },

      768: {
        centeredSlides: false,
        centeredSlidesBounds: false,
        slidesPerView: 2.2,
        spaceBetween: 20,
      },
      920: {
        slidesPerView: 1,
      },
    },
  });
}

innitSwiper();
